module.exports = __webpack_public_path__ + "img/avatar-31.aca881ad.png";